import { render } from "./dashboard-index.vue?vue&type=template&id=6ef34c5e"
import script from "./dashboard-index.vue?vue&type=script&lang=js"
export * from "./dashboard-index.vue?vue&type=script&lang=js"

import "./dashboard-index.vue?vue&type=style&index=0&id=6ef34c5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__